import { render, staticRenderFns } from "./LoginWorldWide.vue?vue&type=template&id=906f38b4&scoped=true&"
import script from "./LoginWorldWide.ts?vue&type=script&lang=ts&"
export * from "./LoginWorldWide.ts?vue&type=script&lang=ts&"
import style0 from "./LoginWorldWide.vue?vue&type=style&index=0&id=906f38b4&lang=vue-scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906f38b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('906f38b4')) {
      api.createRecord('906f38b4', component.options)
    } else {
      api.reload('906f38b4', component.options)
    }
    module.hot.accept("./LoginWorldWide.vue?vue&type=template&id=906f38b4&scoped=true&", function () {
      api.rerender('906f38b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/typo3conf/ext/aus_project/Resources/Private/TypeScript/LoginStatus/Components/LoginWorldWide/LoginWorldWide.vue"
export default component.exports